import { Application } from "@hotwired/stimulus"

const application = Application.start()

// Configure Stimulus development experience
application.debug = false
window.Stimulus   = application

// Track registered controllers and warn when a data-controller appears without registration.
const registeredControllers = new Set()
const originalRegister = application.register.bind(application)
application.register = (identifier, constructor) => {
  registeredControllers.add(identifier)
  return originalRegister(identifier, constructor)
}

const warnOnMissingControllers = () => {
  document.querySelectorAll("[data-controller]").forEach((el) => {
    const names = (el.getAttribute("data-controller") || "").split(/\s+/).filter(Boolean)
    names.forEach((name) => {
      if (!registeredControllers.has(name)) {
        console.warn(`Stimulus: controller \"${name}\" não está registrado em app/javascript/controllers/index.js`)
      }
    })
  })
}

document.addEventListener("DOMContentLoaded", warnOnMissingControllers, { once: true })
document.addEventListener("turbo:load", warnOnMissingControllers)

export { application }
